var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 1.79454C4.14773 2.13565 1.88565 4.39773 1.54454 7.25H3.2C3.61421 7.25 3.95 7.58579 3.95 8C3.95 8.41421 3.61421 8.75 3.2 8.75H1.54454C1.88565 11.6023 4.14773 13.8644 7 14.2055V12.5503C7 12.1361 7.33579 11.8003 7.75 11.8003C8.16421 11.8003 8.5 12.1361 8.5 12.5503V14.2055C11.3523 13.8644 13.6144 11.6023 13.9555 8.75H11.9497C11.5355 8.75 11.1997 8.41421 11.1997 8C11.1997 7.58579 11.5355 7.25 11.9497 7.25H13.9555C13.6144 4.39773 11.3523 2.13565 8.5 1.79454V3.45C8.5 3.86421 8.16421 4.2 7.75 4.2C7.33579 4.2 7 3.86421 7 3.45V1.79454ZM7.75 0.25C12.0302 0.25 15.5 3.71979 15.5 8C15.5 12.2728 12.0423 15.7379 7.7723 15.75C7.76489 15.7502 7.75746 15.7503 7.75 15.7503L7.74146 15.7502L7.7277 15.75C3.45775 15.7379 0 12.2728 0 8C0 3.71979 3.46979 0.25 7.75 0.25Z",
    fill: "#B3B3B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoc);
export default __webpack_public_path__ + "static/media/loc.32ffe95cf460790f1bda21a38b135847.svg";
export { ForwardRef as ReactComponent };